<div [hidden]="!control?.errors || control.valid || hide" class="input-error">
  <span>{{ validator.formatControlErrorMessage(control.errors) }}</span>
</div>
